import React from 'react';
import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';
import PurchaseOrderViewDropdownPresenter from './PurchaseOrderViewDropdownPresenter';

interface Props {
  purchaseOrders: CapaQuotationRfqPurchaseOrder[];
  onClick: (purchaseOrderId: string) => void;
}
const PurchaseOrderViewDropdownContainer = ({
  purchaseOrders,
  onClick
}: Props) => {
  return (
    <PurchaseOrderViewDropdownPresenter
      purchaseOrders={purchaseOrders}
      onClick={onClick}
    />
  );
};

export default PurchaseOrderViewDropdownContainer;
